// sendUserDebugFeedContentError.js
'use strict';
import {
  LIVESTREAM_FEED,
  LIVESTREAM_FEED_SORTINGS,
} from '../RemoteConfigKeys.js';

import trackMixpanel from '../resource/mixpanel.js';
import { EventTypes } from '../resource/trackingConstants.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getRouterData from '../selector/getRouterData.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';

/**
 * Send user debug feed content error
 * @kind action
 * @param {string} {category} - category name.
 * @param {string} {baseRemoteConfigKeyName} - base remote config key name. ex: value will be 'LIVESTREAM_FEED' in livestream feed.
 * @return {Promise} Action promise.
 */
const sendUserDebugFeedContentError =
  ({ category = '', baseRemoteConfigKeyName = '' } = {}) =>
  async (dispatch, getState) => {
    const state = getState();
    const livestreamFeed = getRemoteConfigData(state, LIVESTREAM_FEED);
    const livestreamFeedSortings = getRemoteConfigData(
      state,
      LIVESTREAM_FEED_SORTINGS
    );
    const { feedNameWithQuery } = getSelectedQueryOptionObject(
      state,
      category,
      getSelectedFeedQueryOptions(state, LIVESTREAM_FEED, undefined),
      livestreamFeedSortings?.[0]
    );
    const payload = {
      'feed.alias': category,
      'feed.aliasWithQuery': feedNameWithQuery,
      'remoteConfig.livestreamFeed': livestreamFeed,
      'remoteConfig.livestreamFeedSortings': livestreamFeedSortings.join(' '),
      'current.url': window.location.href,
      'current.pathname': getRouterData(state, 'location.pathname'),
      'current.search': getRouterData(state, 'location.search'),
    };
    try {
      payload['remoteConfig.prefixMatchedEntries'] = state
        .get('remoteConfig')
        .filter((value, key) => key.startsWith(baseRemoteConfigKeyName))
        ?.toJS();
      // eslint-disable-next-line no-empty
    } catch (_) {}
    trackMixpanel({
      type: EventTypes.USER_DEBUG_FEED_CONTENT_ERROR,
      payload,
    });
  };

export default sendUserDebugFeedContentError;
